import React from 'react';
import {
  ItemSearch,
  ItemListContainer,
  SectionTitle,
} from './Styles';

const Help = () => (
  <ItemSearch>
    <>
      <SectionTitle>Help</SectionTitle>
      <ItemListContainer>Add FAQ Items...</ItemListContainer>
    </>
  </ItemSearch>
);

export default Help;
